export var _width = 400;
export var widthFunc = function (length, width) { return ({ width: length === 0 ? "".concat(width, "px") : "".concat(length * width, "px"), minWidth: length === 0 ? "".concat(width, "px") : "".concat(length * width, "px") }); };



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/helpers/Const.ts
// module id = 488
// module chunks = 0